var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleyoutubeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3225180_app_logo_media_popular_social_icon 27",
    clipPath: "url(#clip0_0_11411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 28C6.2692 28 0 21.7308 0 14C0 6.2692 6.2692 0 14 0C21.7308 0 28 6.2692 28 14C28 21.7308 21.7308 28 14 28Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.9097 9.4948C22.6969 8.6884 22.0669 8.0556 21.2661 7.84C19.8157 7.448 14.0029 7.448 14.0029 7.448C14.0029 7.448 8.1873 7.448 6.7397 7.84C5.9389 8.0556 5.3089 8.6884 5.0961 9.4948C4.7041 10.9536 4.7041 14 4.7041 14C4.7041 14 4.7041 17.0464 5.0933 18.5052C5.3061 19.3116 5.9361 19.9444 6.7369 20.16C8.1873 20.552 14.0001 20.552 14.0001 20.552C14.0001 20.552 19.8157 20.552 21.2633 20.16C22.0641 19.9444 22.6941 19.3116 22.9069 18.5052C23.2961 17.0464 23.2961 14 23.2961 14C23.2961 14 23.2961 10.9536 22.9097 9.4948ZM12.0989 16.7636V11.2364L16.9569 14L12.0989 16.7636Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_11411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleyoutubeicon);
export default __webpack_public_path__ + "static/media/circleyoutubeicon.b2ba816170b56c01d55ea7ac120fe2ed.svg";
export { ForwardRef as ReactComponent };